class BurgerMenu extends HTMLElement {
  constructor() {
    super(),
      (this.header = document.querySelector(".header-wrapper")),
      (this.burgerMenu = this.querySelector(".burger-menu")),
      (this.openButton = this.querySelector(".burger-menu__toggle--open-btn")),
      (this.closeButton = this.querySelector(
        ".burger-menu__toggle--close-btn",
      )),
      (this.overlay = this.querySelector(".burger-menu__overlay")),
      this.header && (this.header.preventHide = !1),
      this.setListeners();
  }
  open(e) {
    e.preventDefault(),
      this.header && (this.header.preventHide = !0),
      this.burgerMenu.classList.add("burger-menu--open"),
      this.overlay.classList.add("burger-menu__overlay--active"),
      document.body.classList.add("overflow-hidden-drawer");
  }
  close(e) {
    e.preventDefault(),
      this.burgerMenu.classList.remove("burger-menu--open"),
      this.overlay.classList.remove("burger-menu__overlay--active"),
      document.body.classList.remove("overflow-hidden-drawer"),
      this.header && (this.header.preventHide = !1);
  }
  setListeners() {
    this.openButton?.addEventListener("click", (e) => this.open(e)),
      this.closeButton?.addEventListener("click", (e) => this.close(e)),
      this.overlay?.addEventListener("click", (e) => this.close(e)),
      this.burgerMenu?.addEventListener(
        "keyup",
        (e) => "Escape" === e.code && this.close(e),
      );
  }
}
customElements.get("burger-menu") ||
  customElements.define("burger-menu", BurgerMenu);
